import React, { useState, useCallback } from 'react';
import { FaUsers, FaUser } from 'react-icons/fa';
import './App.css';
import PlayerLeaderboard from './components/PlayerLeaderboard';
import TribeLeaderboard from './components/TribeLeaderboard';

const SITE_URL = 'https://mesark.net';
const STORE_URL = 'https://store.mesark.net/';

function getInitialParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    tab: params.get('tab') || 'tribe',
    cluster: params.get('cluster') || 'SOLO',
    filter: params.get('filter') || '',
    page: parseInt(params.get('page') || '0', 10),
    search: params.get('search') || ''
  };
}

const TABS = [
  { key: 'tribe', index: '01', label: 'Tribes', Icon: FaUsers },
  { key: 'player', index: '02', label: 'Players', Icon: FaUser }
];

function App() {
  const initial = getInitialParams();
  const [activeTab, setActiveTab] = useState(initial.tab === 'player' ? 'player' : 'tribe');

  const updateURL = useCallback((params) => {
    const url = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v && v !== '' && !(k === 'page' && v === 0) && !(k === 'tab' && v === 'tribe')) {
        url.set(k, v);
      }
    });
    const qs = url.toString();
    window.history.replaceState(null, '', qs ? `?${qs}` : window.location.pathname);
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    updateURL({ tab });
  };

  return (
    <div className="App">
      <nav className="site-nav" aria-label="MESA">
        <div className="site-nav-inner">
          <a href={SITE_URL} className="brand" aria-label="MESA ARK home">
            <img src="/logo-256.png" alt="" width="34" height="34" className="brand-logo" />
            <span className="brand-word font-display">MESA</span>
            <span className="brand-tag hud-label">Leaderboards</span>
          </a>
          <div className="nav-links">
            <a href={SITE_URL} className="nav-link font-display">
              mesark.net <span aria-hidden="true">&#8599;</span>
            </a>
            <a href={STORE_URL} className="nav-store font-display clip-corner-sm" target="_blank" rel="noopener noreferrer">
              Store
            </a>
          </div>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-art" aria-hidden="true">
          <img
            className="hero-img"
            src="/art/leaderboard-ark-1920.jpg"
            srcSet="/art/leaderboard-ark-960.jpg 960w, /art/leaderboard-ark-1920.jpg 1920w"
            sizes="100vw"
            alt=""
            decoding="async"
          />
          <div className="hero-shade-x" />
          <div className="hero-shade-y" />
          <div className="hero-glow" />
        </div>
        <div className="hero-content">
          <p className="hud-label kicker"><span className="kicker-line" />MESA ARK // Live rankings</p>
          <h1 className="hero-title font-display">Leaderboards</h1>
          <p className="hero-sub">
            Tribe and player standings across every MESA cluster. Kills, deaths, K/D, tamed dino kills and hours on the island.
          </p>
        </div>
        <div className="hairline hero-hairline" />
      </section>

      <main className="main-content">
        <div className="tab-navigation" role="tablist" aria-label="Leaderboard type">
          {TABS.map(({ key, index, label, Icon }) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={activeTab === key}
              className={`tab-button${activeTab === key ? ' active' : ''}`}
              onClick={() => handleTabChange(key)}
            >
              <span className="tab-index">{index}</span>
              <Icon className="tab-icon" aria-hidden="true" />
              <span className="tab-label font-display">{label}</span>
            </button>
          ))}
        </div>

        <div className="leaderboard-content" role="tabpanel">
          {activeTab === 'tribe'
            ? <TribeLeaderboard initialParams={initial} updateURL={updateURL} />
            : <PlayerLeaderboard initialParams={initial} updateURL={updateURL} />
          }
        </div>
      </main>

      <footer className="site-footer">
        <div className="footer-wordmark font-display" aria-hidden="true">MESA ARK</div>
        <div className="footer-bar">
          <span className="hud-label">MESA ARK &copy; {new Date().getFullYear()}</span>
          <span className="footer-links">
            <a href={SITE_URL} className="hud-label">mesark.net</a>
            <a href={STORE_URL} className="hud-label" target="_blank" rel="noopener noreferrer">Store</a>
          </span>
          <span className="hud-label">Not affiliated with Studio Wildcard</span>
        </div>
      </footer>

      <div className="grain" aria-hidden="true" />
    </div>
  );
}

export default App;
